import { api } from "@/api/client"
import type { ApiResponse, PaginatedResponse } from "@/types/api"
import type { Notification, NotificationPreference } from "@/types/models"

export async function getNotifications() {
  const { data } = await api.get<PaginatedResponse<Notification>>("/api/notifications")
  return data
}

export async function getNotification(id: string) {
  const { data } = await api.get<ApiResponse<Notification>>(`/api/notifications/${id}`)
  return data
}

export async function markAsRead(id: string) {
  const { data } = await api.post<ApiResponse<null>>(`/api/notifications/${id}/mark-read`)
  return data
}

export async function markAllAsRead() {
  const { data } = await api.post<ApiResponse<null>>("/api/notifications/mark-all-read")
  return data
}

export async function getNotificationPreferences() {
  const { data } = await api.get<ApiResponse<NotificationPreference>>("/api/notification-preferences")
  return data
}

export async function updateNotificationPreferences(payload: Partial<NotificationPreference>) {
  const { data } = await api.put<ApiResponse<NotificationPreference>>("/api/notification-preferences", payload)
  return data
}
